import {
  ASSOCIATE_DIRECTOR,
  DIRECTOR,
  EXECUTIVE_DIRECTOR,
  GLOBAL_DIRECTOR,
  INTEGRATED_EXECUTIVE_DIRECTOR,
  INTEGRATED_GLOBAL_DIRECTOR,
  INTEGRATED_NATIONAL_DIRECTOR,
  INTEGRATED_PRESIDENTIAL_DIRECTOR,
  INTEGRATED_REGIONAL_DIRECTOR,
  MANAGER,
  NATIONAL_DIRECTOR,
  PRESIDENTIAL_DIRECTOR,
  REGIONAL_DIRECTOR,
  SENIOR_COACH,
} from '/enum/rank.enum';

export const targetMap = {
  fqv: {
    [INTEGRATED_REGIONAL_DIRECTOR]: 6000,
    [INTEGRATED_NATIONAL_DIRECTOR]: 6000,
  },
  gqv: {
    [SENIOR_COACH]: 1200,
    [MANAGER]: 1200,
    [ASSOCIATE_DIRECTOR]: 1200,
    [DIRECTOR]: 1200,
    [EXECUTIVE_DIRECTOR]: 1200,
    [GLOBAL_DIRECTOR]: 1200,
    [REGIONAL_DIRECTOR]: 1200,
    [NATIONAL_DIRECTOR]: 1200,
    [PRESIDENTIAL_DIRECTOR]: 1200,
    [INTEGRATED_REGIONAL_DIRECTOR]: 15000,
    [INTEGRATED_NATIONAL_DIRECTOR]: 15000,
    [INTEGRATED_GLOBAL_DIRECTOR]: 1200,
    [INTEGRATED_PRESIDENTIAL_DIRECTOR]: 1200,
    [INTEGRATED_EXECUTIVE_DIRECTOR]: 15000,
  },
  orderingEntities: {
    [SENIOR_COACH]: 5,
    [MANAGER]: 5,
    [ASSOCIATE_DIRECTOR]: 5,
    [DIRECTOR]: 5,
    [EXECUTIVE_DIRECTOR]: 5,
  },
  qualifyingPoints: {
    [MANAGER]: 2,
    [ASSOCIATE_DIRECTOR]: 3,
    [DIRECTOR]: 4,
    [EXECUTIVE_DIRECTOR]: 5,
    [REGIONAL_DIRECTOR]: 5,
    [NATIONAL_DIRECTOR]: 5,
    [GLOBAL_DIRECTOR]: 5,
    [PRESIDENTIAL_DIRECTOR]: 5,
  },
  executiveDirectorTeams: {
    [REGIONAL_DIRECTOR]: 1,
    [NATIONAL_DIRECTOR]: 3,
    [GLOBAL_DIRECTOR]: 5,
    [PRESIDENTIAL_DIRECTOR]: 10,
    [INTEGRATED_REGIONAL_DIRECTOR]: 1,
    [INTEGRATED_NATIONAL_DIRECTOR]: 3,
  },
};
